import type { Variant, VariantStyles } from './ScheduleList.types';
import { mergeVariantStyles } from './ScheduleList.utils';

const defaultStyles: VariantStyles = {
  scheduleDayItemContainer: () => ({
    _notFirst: {
      marginTop: [10],
    },
  }),
  header: {
    borderBottom: '1px solid',
    borderBottomColor: 'mono3',
  },
  headerText: {
    textAlign: 'center',
  },
  scheduleDateColumn: () => ({}),
  events: {},
  eventsStack: {
    width: '100%',
  },
  container: {},
  primaryBlockColumns: {
    width: '100%',
    marginTop: [0, null, 0],
  },
  primaryBlock: {
    container: () => ({}),
    infoBlockGroup: () => ({
      paddingTop: 0,
    }),
  },
  secondaryBlockColumns: {
    marginTop: [10],
  },
  secondaryBlock: {
    container: {
      spacing: 5,
    },
    durationBlockContainer: {},
    durationBlock: {
      textAlign: 'center',
    },
    calendarBlock: {
      width: ['auto', 'auto', '260px'],
      paddingX: ['0.75rem', '1rem', '1.5rem'],
    },
    directionBlock: {
      width: 'auto',
      paddingX: ['0.75rem', '1rem'],
    },
  },
};

export const variantStyles: Readonly<Record<Variant, VariantStyles>> = {
  stack: mergeVariantStyles(defaultStyles, {
    scheduleDayItemContainer: (isToBeAnnounced: boolean) => ({
      marginTop: isToBeAnnounced ? [7, null, 0] : [7, null, 8],
    }),
    container: {},
    events: {
      paddingTop: [7, null, 8],
    },
    eventsStack: {
      spacing: [10, null, 6],
    },
    header: {
      paddingBottom: 5,
    },
    headerText: {
      letterSpacing: '0.0625em',
      textTransform: 'none',
    },
    scheduleDateColumn: () => ({}),
    primaryBlockColumns: {
      span: 12,
    },
    primaryBlock: {
      container: () => ({
        marginTop: [0, null, 8],
        marginBottom: [0, null, 8],
      }),
      infoBlockGroup: (hasEventNameMarkup: boolean) => ({
        paddingTop: hasEventNameMarkup ? 0 : [5, null, 0],
      }),
    },
    secondaryBlockColumns: {
      marginTop: [0],
      span: 12,
    },
    secondaryBlock: {
      container: {
        alignItems: 'center',
      },
      durationBlockContainer: {
        textAlign: 'center',
      },
      durationBlock: {
        marginTop: 5,
        color: 'mono10',
      },
      calendarBlock: {},
      directionBlock: {},
    },
  }),
  inline: mergeVariantStyles(defaultStyles, {
    scheduleDayItemContainer: () => ({
      marginTop: [7, null, 10],
    }),
    container: {}, //{ span: [12, 10], offset: [null] },
    events: {},
    eventsStack: {
      spacing: 10,
    },
    header: {
      paddingBottom: 5,
    },
    headerText: {
      letterSpacing: '0.0625em',
      textTransform: 'none',
    },
    scheduleDateColumn: () => ({}),
    primaryBlockColumns: {
      span: [12, 'five-eigths'],
    },
    primaryBlock: {
      container: () => ({
        marginTop: 0,
      }),
      infoBlockGroup: (hasEventNameMarkup: boolean) => ({
        paddingTop: hasEventNameMarkup ? 0 : 5,
      }),
    },
    secondaryBlockColumns: {
      span: [12, 'three-eigths'],
      marginTop: 0,
    },
    secondaryBlock: {
      container: {
        alignItems: ['center', null, 'flex-start'],
        marginTop: ['0.125rem'],
      },
      durationBlockContainer: {
        textAlign: ['center', null, 'left'],
      },
      durationBlock: {
        marginTop: [5, 0],
        color: 'mono10',
        textAlign: ['center', null, 'left'],
      },
      calendarBlock: {},
      directionBlock: {},
    },
  }),
};
